import { ValidationStudentApiError } from '@/infrastructure/clients/studentapi/errors/validation-student-api-error';
import { UnknownStudentApiError } from '@/infrastructure/clients/studentapi/errors/unknown-student-api-error';
import { UnknownLinkedInError } from '@/infrastructure/clients/linkedin/errors/unknown-linkedin-error';
import { UnknownGoogleError } from '@/infrastructure/clients/google/errors/unknown-google-error';
import { UnknownFacebookError } from '@/infrastructure/clients/facebook/errors/unknown-facebook-error';
import { ProviderPopupClosedError } from '@/infrastructure/clients/errors/provider-popup-closed-error';

export class ErrorDisplayService {
	public errorMessage(error: Error): string {
		// Student Api Errors
		// { return "You have previously signed up via google. Please use google to access your account."; }
		if (error instanceof ValidationStudentApiError) {
			return 'Something went wrong.';
		}
		if (error instanceof UnknownStudentApiError) {
			return 'Something went wrong.';
		}
		if (error instanceof UnknownLinkedInError) {
			return 'Something went wrong connecting to LinkedIn. Give it another try!';
		}
		// Google
		if (error instanceof UnknownGoogleError) {
			return 'Something went wrong connecting to Google. Give it another try!';
		}
		// Facebook
		if (error instanceof UnknownFacebookError) {
			return 'Something went wrong connecting to Facebook. Give it another try!';
		}
		// Overall Popup
		if (error instanceof ProviderPopupClosedError) {
			return 'Something went wrong.';
		}
		return 'Something went wrong.';
	}
}
